import { makeVuexProp, mergeModules } from '../../utils/vuexUtils';
import removeNamespace from '../../utils/vueUtils';
import settings from '../../data/settings';

const moduleName = 'User';

let localStorageKey = 'UserSettings-TisztaTisza';

let savedStore = JSON.parse(localStorage.getItem(localStorageKey)) || {};

let UserStoreTypes = {};
let baseModul = {
  namespaced: true,
  state: {
    localStorageKey: localStorageKey,
  },
  getters: {},
  actions: {},
  mutations: {},
};

let user = mergeModules([], baseModul);

export { user, UserStoreTypes };
